(() => {
  if (window.first3dColourGalleryInstalled) return;
  window.first3dColourGalleryInstalled = true;
  const state = new Map();
  function sync() {
    document.querySelectorAll('[data-first3d-colour-config]').forEach(node => {
      let config; try { config = JSON.parse(node.textContent); } catch (_) { return; }
      const root = document.getElementById('MainProduct-' + config.section);
      if (!root) return;
      const picker = root.querySelector('variant-selects');
      if (!picker) return;
      let selected = 'Gold';
      picker.querySelectorAll('input[type="radio"]').forEach(input => {
        if (!['Gold', 'Coral'].includes(input.value)) return;
        if (input.checked) selected = input.value;
        const label = Array.from(picker.querySelectorAll('label')).find(l => l.htmlFor === input.id);
        if (label && !label.querySelector('.first3d-colour-icon')) {
          const image = document.createElement('img');
          image.className = 'first3d-colour-icon'; image.alt = ''; image.width = 32; image.height = 32;
          image.src = input.value === 'Gold' ? config.goldIcon : config.coralIcon;
          label.prepend(image); label.classList.add('first3d-colour-option');
        }
      });
      picker.querySelectorAll('select').forEach(select => {
        if (['Gold','Coral'].includes(select.value)) selected = select.value;
      });
      const mediaMap = new Map(config.media.map(m => [m.id, m.colour]));
      const gallery = root.querySelector('media-gallery');
      if (!gallery) return;
      const modal = document.getElementById('ProductModal-' + config.section);
      [gallery, modal].filter(Boolean).forEach(container => {
        container.querySelectorAll('[data-media-id], [data-target]').forEach(item => {
          const raw = item.dataset.mediaId || item.dataset.target || '';
          const id = raw.split('-').pop(); const colour = mediaMap.get(id);
          if (!colour) return;
          item.classList.toggle('first3d-colour-hidden', colour !== selected);
        });
      });
      const old = state.get(config.section);
      if (!old || old.colour !== selected || old.gallery !== gallery) {
        const featured = config.featured[selected] || config.media.find(m => m.colour === selected)?.id;
        if (featured && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(config.section + '-' + featured, false);
        gallery.querySelectorAll('slider-component').forEach(slider => {
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
        state.set(config.section, { colour: selected, gallery });
      }
    });
  }
  let scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; sync(); }); }
  document.addEventListener('change', e => { if (e.target.closest('variant-selects')) schedule(); });
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
